import type { Theme } from '@mui/material/styles'

const iconSize = 20

export const sidebarItemConfig = {
  iconSize,

  iconSx: {
    color: (theme: Theme) => theme.palette.primary.main,
    width: iconSize,
    height: iconSize,
  },

  itemSx: {
    display: 'flex',
    alignItems: 'center',
    borderRadius: 1,
    gap: 0.5,
    px: 0.5,
    cursor: 'pointer',

    '&:hover': {
      backgroundColor: (theme: Theme) => theme.palette.action.hover,
    },
  },
}
